var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 397.406 397.406",
    viewBox: "0 0 397.406 397.406",
    width: 30,
    height: 30,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffff",
    d: "M397.112 153.585a5.999 5.999 0 00-5.149-4.12l-134.331-12.522-53.419-123.886a6 6 0 00-11.02 0l-53.419 123.886L5.443 149.465a6 6 0 00-3.405 10.48l101.315 89.087-29.6 131.625a6 6 0 008.914 6.477l116.035-68.827 116.036 68.827a5.996 5.996 0 006.587-.307 5.996 5.996 0 002.327-6.17l-29.601-131.625 101.315-89.087a5.996 5.996 0 001.746-6.36zm-113.656 88.786a6.003 6.003 0 00-1.892 5.822l27.328 121.522-107.129-63.543a6.002 6.002 0 00-6.122 0L88.514 369.714l27.328-121.522a6 6 0 00-1.892-5.822l-93.539-82.249 124.021-11.562a6 6 0 004.953-3.598l49.318-114.376 49.318 114.376a6 6 0 004.953 3.598l124.021 11.562-93.539 82.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffff",
    d: "M200.54 106.018a2 2 0 00-3.674 0l-29.485 68.378-74.143 6.913a2.001 2.001 0 00-1.135 3.493l55.921 49.172-16.338 72.65a2 2 0 002.971 2.159l64.046-37.988 64.047 37.988a2 2 0 002.972-2.159l-16.337-72.65 55.92-49.172a2.001 2.001 0 00-1.135-3.493l-74.145-6.913-29.485-68.378z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.6e1a8f8a2705a7dc2da0d67a2806c314.svg";
export { ForwardRef as ReactComponent };